export default "__VITE_ASSET__D$Dq2BMG__"